import { cn, Tooltip } from '@ds';
import { CS_DEDUCTION_RULE_ABSENCE_DAYS } from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/config';
import { csDeductionRuleColumns } from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/constants';
import { CSDeductionRuleTableRow } from '../sections';

type CSSchedulerSettingsDeductionRulesFormProps = {
  isReadOnly: boolean;
};

export const CSSchedulerSettingsDeductionRulesForm = ({ isReadOnly }: CSSchedulerSettingsDeductionRulesFormProps) => {
  return (
    <div className="flex flex-col rounded-xl bg-white p-5 shadow-s max-w-350">
      <h2 className="text-hm text-base-5 mb-3">Absence Deduction Table</h2>
      <table
        aria-label="Absence deduction table"
        className="relative border-separate border-spacing-0 bg-white rounded-lg w-full table-fixed"
      >
        <thead className="bg-base-70">
          <tr>
            {csDeductionRuleColumns.map((column) => (
              <th key={column.key} className="px-3 py-2 text-right text-s-sb text-base-20 font-semibold">
                <Tooltip showArrow content={column.tooltip} placement="bottom" className="max-w-[254px]">
                  <span className="inline-flex items-center gap-1 justify-end decoration-dotted hover:underline">
                    {column.dotColor && <span className={cn('size-[5px] rounded-full shrink-0', column.dotColor)} />}
                    {column.label}
                  </span>
                </Tooltip>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {CS_DEDUCTION_RULE_ABSENCE_DAYS.map((absenceDays) => (
            <CSDeductionRuleTableRow key={absenceDays} absenceDays={absenceDays} isReadOnly={isReadOnly} />
          ))}
        </tbody>
      </table>
    </div>
  );
};
